import React, { Fragment, useContext, useEffect } from "react";
import NavBar from "../../features/nav/NavBar";
import WorkOrderDashboard from "../../features/workorders/dashboard/WorkOrderDashboard";
import { Container } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Route, Redirect } from "react-router-dom";
import HomePage from "../../features/home/HomePage";
import Login from "../../features/login/Login";
import userauthStore from "../stores/userauthStore";
import AllDash from "../../features/workorders/dashboard/AllDash";
import PowerBi from "../../features/workorders/dashboard/Powerbi";
import Budget from "../../features/workorders/dashboard/BudgetTracker";
import variationsDash from "../../features/workorders/dashboard/variationsDash";
import RedKiteDash from "../../features/workorders/dashboard/RedkiteDash";
import LKAvailabilityDash from "../../features/workorders/dashboard/lookahead/AvailabilityDash";
import LKJobDash from "../../features/workorders/dashboard/lookahead/JobDash";
import RKAvailabilityDash from "../../features/workorders/dashboard/redkite/RKAvailabilityDash";
import RKJobDash from "../../features/workorders/dashboard/redkite/RKJobDash";
import AgedDebt from "../../features/workorders/dashboard/AgedDebt";


const App = () => {

  const userAuthStore = useContext(userauthStore);
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 
  let IsLoggedIn = sessionStorage.getItem("isLoggedIn")
  
  useEffect(() => {
   userAuthStore.HydrateAuthState();
   console.log(IsLoggedIn);
   console.log(sessionObj);
  }, [sessionObj, IsLoggedIn,userAuthStore]);

  const PrivateRoute = ({ component: Component, ...rest }:any) => (
    
    <Route {...rest} render={(props) => (
       
      userAuthStore.isLoggedIn === true || IsLoggedIn === "true" 
        ? <Component {...props} />
        : <Redirect to='/login' />
    )} />
  )


  
  return (
    <React.Fragment>
      <NavBar />
      <Container style={{ marginTop: "6em" }}>
        <Route exact path="/login" component={Login} />
        <PrivateRoute exact path="/" component={HomePage} />
        <PrivateRoute exact path="/workorders" component={variationsDash} />
        <PrivateRoute exact path="/variations" component={WorkOrderDashboard} />
        <PrivateRoute exact path="/lookaheadavailability" component={LKAvailabilityDash} />
        <PrivateRoute exact path="/lookaheadjobs" component={LKJobDash}/>
        <Route path="/lkjob/:JobNumber" component={LKAvailabilityDash} />

        <PrivateRoute exact path="/redkiteavailability" component={RKAvailabilityDash} />
        <PrivateRoute exact path="/redkitejobs" component={RKJobDash}/>
        <Route path="/rkjob/:JobNumber" component={RKAvailabilityDash} />

        <PrivateRoute exact path="/liveorders" component={AllDash}/>
        <PrivateRoute exact path="/dashboards" component={PowerBi}/>
        <PrivateRoute exact path="/budget" component={Budget}/>
        <PrivateRoute exact path="/RKD" component={RedKiteDash}/>
        <PrivateRoute exact path="/ageddebt" component={AgedDebt}/>

      </Container>
      </React.Fragment>
    
  );
};

export default observer(App);
